import React from "react";
import { Crown, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PremiumPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleViewCourse = () => {
    onClose(); // popup close
    navigate("/dash/plan"); // redirect
  };

  return (
    <div className="w-full max-w-sm rounded-2xl overflow-hidden bg-gradient-to-b from-[#5B2DA6] to-[#2B0B4D] border border-[#F7B733] shadow-2xl">
      <div className="flex flex-col items-center px-6 pt-6">
        <div className="w-14 h-14 rounded-full bg-[#F7B733] flex items-center justify-center shadow-lg">
          <Crown size={24} className="text-black" />
        </div>

        <h2 className="mt-5 text-center text-[#F7B733] font-bold text-2xl">
          Unlock Premium To Continue
          <br />
          Unlimited Preparation
        </h2>

        <div className="mt-6 w-full space-y-4">
          {[
            "1,00,000 Questions Access",
            "Unlimited Quiz Attempts",
            "Performance Tracking & Rewards",
            "24×7 Support",
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <CheckCircle size={16} className="text-[#F7B733]" />
              <span className="text-white text-sm">{item}</span>
            </div>
          ))}
        </div>
        <p className="text-[#F7B733] pt-6 font-bold">Practice Daily,Improve Rank,Get Rewards</p>
        <button
          onClick={handleViewCourse}
          className="mt-6 w-full rounded-full border border-[#F7B733] bg-gradient-to-r from-[#4B1F82] to-[#6A38C2] py-3 text-white font-bold"
        >
          View Course
        </button>

        <button
          onClick={onClose}
          className="mt-4 mb-5 text-white/80 text-sm font-semibold"
        >
          MAYBE LATER
        </button>
      </div>
    </div>
  );
};

export default PremiumPopup;